import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import { useEffect, useState } from "react";
import WalletIcon from "@mui/icons-material/Wallet";
import { updateIbWallet, getCustomerDataForPayouts } from "../../../../../services/customers/customers.services";
import { useSnackbar } from "../../../../../context/SnackbarContext";
import { sharingInformationService } from "../sharingInfo.service";

export function WalletConfig({ currency }) {
  const [isEditing, setIsEditing] = useState(false);
  const [walletId, setWalletId] = useState("");
  const [initialWalletId, setInitialWalletId] = useState("");
  const [userInfo, setUserInfo] = useState(null);

  const [imagePreview, setImagePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); 

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { showSnackbar } = useSnackbar();

  const handleUpdateWalletClick = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  const handleSaveWalletClick = async (e) => {
    e.preventDefault();
    if (walletId === initialWalletId && imagePreview === null) {
      setIsEditing(false);
      return;
    }

    if (walletId !== initialWalletId && imagePreview === null){
      showSnackbar({
        message: "Debe actualizar también la imagen",
        type: "error",
      });
      return;
    }
  
    const { success, data, kindMessage } = await updateIbWallet({ walletId, walletImg: selectedFile });
  
    if (success) {
      setIsEditing(false);
      setWalletId(data.item.walletId);
      setInitialWalletId(data.item.walletId);
      setUserInfo(data.item);
      setSelectedFile(null);
      setImagePreview(null);
      showSnackbar({ message: "Wallet actualizada", type: "success" });
      sharingInformationService.setSubject(success);
    } else {
      showSnackbar({
        message: kindMessage || "Ocurrió un error inesperado, inténtalo luego",
        type: "error",
      });
    }
  };

  const fetchWalletInfo = async () => {
    const { success, data } = await getCustomerDataForPayouts();
    if (success && data.item?.walletId) {
      setWalletId(data.item.walletId);
      setInitialWalletId(data.item.walletId);
      setUserInfo(data.item);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };

  useEffect(() => {
    fetchWalletInfo();
  }, []);

  const downloadWallet = () => {
    const link = document.createElement("a");
    link.href = userInfo?.walletImg.url;
    link.download = "wallet.png";
    link.click();
  };

  return (
    <VuiBox>
      <Grid
        onChange={(e) => {
          if (!e.target.value.includes(" ")) {
            setWalletId(e.target.value);
          }
        }}
        container
        sx={{ padding: "13px 13px 0px 13px" }}
        gap={1}
      >
        <Typography
          sx={({ breakpoints }) => ({
            fontSize: "16px",
            fontWeight: "700",
            lineHeight: "24px",
            color: "#FFFFFF",
            [breakpoints.down("md")]: {
              fontSize: "16px",
            },
          })}
        >
          Ingresar dirección e imagen de su wallet {currency?.fullName}
        </Typography>
      </Grid>
      <Grid
        onChange={(e) => {
          if (e.target.type === "file") return;
          if (!e.target.value.includes(" ")) {
            setWalletId(e.target.value);
          }
        }}
        container
        sx={{ padding: "13px 13px 0px 13px", display: "flex", flexDirection: "column" }}
        gap={1}
      >
        <Grid sx={{ display: "flex", flexDirection: "row" }}>
          <Grid item xs={12} md={6}>
            <VuiInput
              type="text"
              placeholder="Ingresa tu wallet"
              value={walletId}
              onChange={(e) => {
                if (!e.target.value.includes(" ")) {
                  setWalletId(e.target.value);
                }
              }}
              sx={({ typography: { size } }) => ({
                fontSize: size.md,
                height: "48px",
                pointerEvents: !isEditing && "none",
              })}
              readOnly={!isEditing}
            />
          </Grid>

          <Grid item xs={isEditing ? 5 : 6} md={3}>
            {isEditing ? (
              <Button
                onClick={handleSaveWalletClick}
                color="primary"
                variant="contained"
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  lineHeight: "21px",
                  height: "48px",
                  width: "100%",
                  maxWidth: "152px",
                  cursor: walletId ? "pointer" : "default",
                }}
              >
                Guardar
              </Button>
            ) : (
              <Button
                onClick={handleUpdateWalletClick}
                color="info"
                variant="text"
                sx={({ breakpoints }) => ({
                  fontSize: "14px",
                  fontWeight: "700",
                  lineHeight: "21px",
                  height: "48px",
                  backgroundColor: "#011a3d",
                  textDecoration: "underline",
                  textTransform: "none",
                  padding: "0rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.2rem",
                  [breakpoints.up("md")]: { marginLeft: "1rem" },
                })}
              >
                <WalletIcon />
                Actualizar wallet
              </Button>
            )}
          </Grid>
        </Grid>

        <Grid style={{ marginTop: "0px", marginLeft: "6px" }}>
          {userInfo?.walletImg.url ? (
            <Grid>
             <Typography sx={{ fontSize: "14px", fontWeight: "700", lineHeight: "21px", color: "#FFFFFF" }}>
                Tipo de archivos permitidos: .jpg, .jpeg, .png. Máximo de tamaño de archivo: 5MB
              </Typography>
              <input
                style={{ display: "none" }}
                type="file"
                id="fileInputEdit"
                accept=".jpg, .jpeg, .png"
                onChange={handleFileChange}
              />
              {isEditing ? (
                <>
                  {imagePreview ? (
                    <Grid sx={{ display: "inline-block", height: "80px" }}>
                      <label htmlFor="fileInputEdit" style={{ cursor: "pointer" }}>
                        <div style={{ position: "relative", width: "80px", height: "80px" }}>
                          <img
                            src={imagePreview}
                            alt="wallet-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                              opacity: "0.7",
                            }}
                          />
                          <span
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              color: "white",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              borderRadius: "5px",
                              padding: "5px 10px",
                              fontSize: "12px",
                            }}
                          >
                            Editar
                          </span>
                        </div>
                      </label>
                    </Grid>
                  ) : (
                    <Grid sx={{ display: "inline-block", height: "80px" }}>
                      <label htmlFor="fileInputEdit" style={{ cursor: "pointer" }}>
                        <div style={{ position: "relative", width: "80px", height: "80px" }}>
                          <img
                            src={userInfo?.walletImg.url}
                            alt="wallet-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                              opacity: "0.7",
                            }}
                          />
                          <span
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              color: "white",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              borderRadius: "5px",
                              padding: "5px 10px",
                              fontSize: "12px",
                            }}
                          >
                            Editar
                          </span>
                        </div>
                      </label>
                    </Grid>
                  )}
                </>
              ) : (
                <>
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="wallet-image"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  ) : (
                    <img
                      src={userInfo?.walletImg.url}
                      alt="wallet-image"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  )}
                </>
              )}
            </Grid>
          ) : (
            <Grid>
              <Typography sx={{ fontSize: "14px", fontWeight: "700", lineHeight: "21px", color: "#FFFFFF" }}>
                Tipo de archivos permitidos: .jpg, .jpeg, .png. Máximo de tamaño de archivo: 5MB
              </Typography>
              <input
                style={{ display: "none" }}
                type="file"
                id="fileInputEdit"
                accept=".jpg, .jpeg, .png"
                onChange={handleFileChange}
              />
              {isEditing ? (
                <>
                  {imagePreview ? (
                    <Grid sx={{ display: "inline-block", height: "80px" }}>
                      <label htmlFor="fileInputEdit" style={{ cursor: "pointer" }}>
                        <div style={{ position: "relative", width: "80px", height: "80px" }}>
                          <img
                            src={imagePreview}
                            alt="wallet-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                              opacity: "0.7",
                            }}
                          />
                          <span
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              color: "white",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              borderRadius: "5px",
                              padding: "5px 10px",
                              fontSize: "12px",
                            }}
                          >
                            Editar
                          </span>
                        </div>
                      </label>
                    </Grid>
                  ) : (
                    <>
                      <Grid sx={{ display: "inline-block", height: "80px" }}>
                        <label htmlFor="fileInputEdit" style={{ cursor: "pointer" }}>
                          <div style={{ position: "relative", width: "80px", height: "80px" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="80px"
                              height="80px"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M17 17H17.01M15.6 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H8.4M12 15V4M12 4L15 7M12 4L9 7"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <span
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                borderRadius: "5px",
                                fontSize: "16px",
                                fontWeight: "700",
                              }}
                            >
                              Subir
                            </span>
                          </div>
                        </label>
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                <>
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="wallet-image"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="80px"
                      height="80px"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M17 17H17.01M15.6 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H8.4M12 15V4M12 4L15 7M12 4L9 7"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      {!isEditing && userInfo?.walletImg.url ? (
        <Grid sx={{ marginTop: "-10px", marginLeft: "10px" }}>
          <Button
            sx={{
              height: "10px",
              borderRadius: "10px",
              color: "white !important",
              fontWeight: "700",
              fontSize: "12px",
              "&:hover": {
                color: "white !important",
              },
            }}
            onClick={handleOpen}
          >
            Ver wallet
          </Button>
        </Grid>
      ) : (
        <></>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            height: 400,
            bgcolor: "#011a3d",
            border: "2px solid #000",
            borderRadius: 6,
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            p: 4,
          }}
        >
          <img
            src={userInfo?.walletImg.url}
            alt="wallet-image"
            style={{
              width: "300px",
              height: "300px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
          <Button
            variant="outlined"
            sx={{
              height: "5px",
              borderRadius: "10px",
              color: "white !important",
              fontWeight: "700",
              fontSize: "12px",
              marginTop: "15px",
              "&:hover": {
                color: "white !important",
              },
            }}
            onClick={downloadWallet}
          >
            Descargar
          </Button>
        </Box>
      </Modal>
    </VuiBox>
  );
}
